import UI from "./base/UI";

import Swiper from "swiper";
import SwiperCore, {EffectCube, EffectFade} from "swiper";
import {SWIPER_GLOBAL_COMMON} from "../utils/constants";
import {getCardToastTmpl} from "./templates/html.template";
import {scrollTo, AnimateProgress, Confetti} from "../functions/simple.ui";

import { 
    isA11yCheckVersion, 
    isA11yTrnCarousel, 
    isA11yButtonRole,
    isA11yCarouselSelect,
    a11yDebounceLeading,
} from "../functions/a11y.ui";
import DateSpinner from "./DateSpinner";

SwiperCore.use([EffectCube]);
SwiperCore.use([EffectFade]);
/**
 * UISwiper
 */

/**
#### HTML 구조 및 Data 속성 사용법
** [http://172.20.160.28:9700/kbank_html_mmk/components/component_swiper.html](http://172.20.160.28:9700/kbank_html_mmk/components/component_swiper.html)
*/
class UISwiper extends UI {
    defaults = {
        no: 0,
        nav: false,
        a11yNav: false,
        paging: false,
        pagingtype: undefined,
        pagingTitle: undefined,
        slidesPerView: 'auto',
        spaceBetween: 20,
        autoplay: undefined,
        updateOnWindowResize: true,
        autoHeight: false,
        effect:'slide',
        direction:'horizontal',
        callbackfn:null,
        ctaDefaultText:'',
        ctaEndText:'',
        touchRatio : 1,
        allowTouch: true,
        speed: 300, // CHPFMTASK-2272 스피드 기본값 300 => 500 으로 수정
        a11yPaging: false,
        preventClick:true,
        reverseAutoplay: undefined,
        centeredSlides: false,
    };

    constructor(el, options) {
        super('uiSwiper', el);

        this.init(el, options);
    }
    // 내부함수
    init(el, options) {
        this.defaults = {...this.defaults, ...this.parseOptions(options)};
        
        this.render();
    }
    // 내부함수
    render() {
        this.detachEvents();
        this.attachEvents();
    }
    // 내부함수
    attachEvents() {
        let initNum;
        if (typeof this.$el.attr('data-no') !== 'undefined') {
            initNum = Number(this.$el.attr('data-no'))
        } else {
            initNum = this.defaults.no;
        }
        

        /*! s: FETASK-a11y page Swiper 옵션 수정 v.1.0.0 */
        let isA11yCheck = isA11yCheckVersion();
        /*! e: FETASK-a11y page Swiper 옵션 수정 v.1.0.0 */
        let options = {
           ...SWIPER_GLOBAL_COMMON, 
            ...this.defaults,
            resistanceRatio: this.$el.find('.swiper-slide').length > 1 ? 0.85 : 0,
            initialSlide: initNum,
            effect: this.defaults.effect,
            direction:this.defaults.direction,
        };

        //접근성 옵션 추가
        Object.assign(options, {
            // a11y: false, 
            a11y: true, // 구소스 개인PC 접근성 관련 수정 (A11YTASK-536, A11YTASK-541, A11YTASK-542)
            ...SWIPER_GLOBAL_COMMON.a11y['paginationBulletMessage']=''
        });

        $('.carousel-group').attr('aria-hidden','true');

        setTimeout(() => {
            $('.carousel-group').removeAttr('aria-hidden');
        },1200);

        if (this.defaults.nav) {
            !this.$el.find('.swiper-button-next').length &&
            this.$el.append(`<div class="swiper-button-prev" role="button" aria-hidden="false"></div><div class="swiper-button-next" role="button" aria-hidden="false"></div>`);
            if (this.$el.find('.swiper-slide').length == 1) {
                this.$el.find('.swiper-button-prev').css('display','none')
                this.$el.find('.swiper-button-next').css('display','none')
                this.$el.find('.swiper-button-prev').attr('aria-hidden','true')
                this.$el.find('.swiper-button-next').attr('aria-hidden','true')
            }

            /*! s: FETASK-a11y page isA11yUiSwiper v.1.0.0 */
            const that = this;
            //a11y시 해당 옵션 추가
            options = {
                ...options, ...{
                    navigation: {
                        prevEl: this.$el.find('.swiper-button-prev')[0],
                        nextEl: this.$el.find('.swiper-button-next')[0],
                    },
                    on:{
                        beforeInit: (sw) => {
                            that.isRemoveSwiperWrapLive();
                            setTimeout(() => {
                                that?.isA11yUiSwiper(sw, 'init', "this.defaults.nav");
                            },100);
                        },
                        slideChangeTransitionStart: (sw) => {
                            that?.isA11yUiSwiper(sw);
                        },
                    }
                },
            };
            /* 접근성 분기코드
            if(isA11yCheck){
                const that = this;
                //a11y시 해당 옵션 추가
                options = {
                    ...options, ...{
                        navigation: {
                            prevEl: this.$el.find('.swiper-button-prev')[0],
                            nextEl: this.$el.find('.swiper-button-next')[0],
                        },
                        on:{
                            beforeInit: (sw) => {
                                that.isRemoveSwiperWrapLive();
                                setTimeout(() => {
                                    that?.isA11yUiSwiper(sw, 'init', "this.defaults.nav");
                                },100);
                            },
                            slideChangeTransitionStart: (sw) => {
                                that?.isA11yUiSwiper(sw);
                            },
                        }
                    },
                };
            }else{
                options = {
                    ...options, ...{
                        navigation: {
                            prevEl: this.$el.find('.swiper-button-prev')[0],
                            nextEl: this.$el.find('.swiper-button-next')[0],
                        },
                    }
                };
            }
            */
        }
        // if (this.defaults.paging && this.defaults.autoplay){
        //     console.log(this.swiper)
        //     this.isA11yAutoPlayAccess(this.swiper)
        // }

        if (this.defaults.a11yNav) {
            if(isA11yCheck){

                console.log('a11yNav')
                !this.$el.find('.swiper-button-next').length &&
                this.$el.append(`<div class="swiper-button-prev" role="button" aria-hidden="false"></div><div class="swiper-button-next" role="button" aria-hidden="false"></div>`);
                if (this.$el.find('.swiper-slide').length == 1) {
                    this.$el.find('.swiper-button-prev').css('display','none')
                    this.$el.find('.swiper-button-next').css('display','none')
                    this.$el.find('.swiper-button-prev').attr('aria-hidden','true')
                    this.$el.find('.swiper-button-next').attr('aria-hidden','true')
                }

                /*! s: FETASK-a11y page isA11yUiSwiper v.1.0.0 */
                const that = this;
                let setView = 'auto';
                //a11y시 해당 옵션 추가
                options = {
                    ...options, ...{
                        slidesPerView: isA11yCheck && !$('html').hasClass('pc') ? 1 : this.defaults.slidesPerView ? this.defaults.slidesPerView : 'auto',
                        centeredSlides: isA11yCheck && !$('html').hasClass('pc') ? true : this.defaults.centeredSlides ? true : false,
                        navigation: {
                            prevEl: this.$el.find('.swiper-button-prev')[0],
                            nextEl: this.$el.find('.swiper-button-next')[0],
                        },
                        on:{
                            beforeInit: (sw) => {
                                that.isRemoveSwiperWrapLive();
                                setTimeout(() => {
                                    that?.isA11yUiSwiper(sw, 'init', "this.defaults.nav");
                                },100);
                            },
                            slideChangeTransitionStart: (sw) => {
                                that?.isA11yUiSwiper(sw);
                            },
                        }
                    },
                };
            }
        }

        if (this.defaults.a11yPaging && this.$el.find('.swiper-slide').length > 1 ) {
            if(isA11yCheck){
                console.log('a11yPaging')
                !this.$el.find('.swiper-pagination').length && this.$el.append(`<div class="swiper-pagination"></div>`);
                /*! s: FETASK-a11y page isA11yUiSwiper v.1.0.0 */
                const that = this;
                //a11y시 해당 옵션 추가
                options = {
                    ...options, ...{
                        slidesPerView: isA11yCheck && !$('html').hasClass('pc') ? 1 : this.defaults.slidesPerView ? this.defaults.slidesPerView : 'auto',
                        centeredSlides: isA11yCheck && !$('html').hasClass('pc') ? true : this.defaults.centeredSlides ? true : false,
                        pagination: {
                            el: this.$el.find('.swiper-pagination')[0],
                            clickable: true
                        },
                        on:{
                            init: (sw) => {
                                that.isRemoveSwiperWrapLive();
                                setTimeout(() => {
                                    that?.isA11yUiSwiper(sw, 'init', "this.defaults.a11yPaging && this.$el.find('.swiper-slide').length > 1");
                                },100);
                            },
                            slideChange: (sw) => {
                                that?.isA11yUiSwiper(sw);
                            },
                        }
                    },
                };

                if (this.defaults.pagingTitle) {
                    setTimeout(() => {
                        this.$el.find('.swiper-pagination').attr('data-paging-title', this.defaults.pagingTitle);
                    });
                }
            }
        }

        if (this.defaults.paging && this.$el.find('.swiper-slide').length > 1 ) {
            !this.$el.find('.swiper-pagination').length && this.$el.append(`<div class="swiper-pagination"></div>`);
            /*! s: FETASK-a11y page isA11yUiSwiper v.1.0.0 */
            const that = this;
            //a11y시 해당 옵션 추가
            options = {
                ...options, ...{
                    pagination: {
                        el: this.$el.find('.swiper-pagination')[0],
                        clickable: true
                    },
                    on:{
                        init: (sw) => {
                            that.isRemoveSwiperWrapLive();
                            setTimeout(() => {
                                that?.isA11yUiSwiper(sw, 'init', "this.defaults.paging && this.$el.find('.swiper-slide').length > 1");
                            },100);
                        },
                        slideChange: (sw) => {
                            that?.isA11yUiSwiper(sw);
                        },
                    }
                },
            };

            
            /*! e: FETASK-a11y page isA11yUiSwiper v.1.0.0 */

            /*! s: FETASK-a11y page isA11yUiSwiper v.1.0.0 */
            if (this.defaults.pagingtype) {
                if(this.defaults.pagingtype === 'fraction'){
                    //pagingtype -> fraction일때 a11y적용
                    //TODO - isA11yCheck 삭제 필요
                        const that = this;
                        options = {
                            ...options, ...{
                                pagination: {
                                    el: this.$el.find('.swiper-pagination')[0],
                                    type: this.defaults.pagingtype
                                },
                                on:{
                                    beforeInit: (sw) => {
                                        that.isRemoveSwiperWrapLive();
                                        setTimeout(() => {
                                            that.isA11yUiSwiper(sw, 'init', "this.defaults.pagingtype === 'fraction'");
                                        },100);
                                    },
                                    slideChange: (sw) => {
                                        //TODO - slide 주식투자 시작하기 자동 슬라이드
                                        console.log('this.defaults.pagingtype === "fraction"');
                                        that.isA11yUiSwiper(sw);
                                    }
                                }
                            }
                        };
                }
                /*
                else{
                    options = {
                        ...options, ...{
                            pagination: {
                                el: this.$el.find('.swiper-pagination')[0],
                                type: this.defaults.pagingtype
                            },
                        }
                    };
                }
                */
            }
            /*! s: FETASK-a11y page isA11yUiSwiper v.1.0.0 */

            if (this.defaults.pagingTitle) {
                setTimeout(() => {
                    this.$el.find('.swiper-pagination').attr('data-paging-title', this.defaults.pagingTitle);
                });
            }
        }
        // 속도조절 추가
        if (this.defaults.speed) {
            options = {
                ...options, ...{
                    speed: this.defaults.speed
                }
            };
        }
        if (this.defaults.autoHeight) {
            options = {
                ...options, ...{
                    autoHeight: this.defaults.autoHeight
                }
            };
        }
        if (!this.defaults.allowTouch) { // FETASK-1961 추가 수동 스와이프 금지
            options = {
                ...options, ...{
                    allowTouchMove: this.defaults.allowTouch
                }
            };
        }
        if (this.defaults.touchRatio) { // FETASK-1961  터치시 auto 멈춤
            options = {
                ...options, ...{
                    touchRatio: this.defaults.touchRatio
                }
            };
        }
        if (this.defaults.direction) {
            options = {
                ...options, ...{
                    direction: this.defaults.direction
                }
            };
        }
        if (this.defaults.effect) {
            options = {
                ...options, ...{
                    effect: this.defaults.effect
                }
            };
        }

        if (this.defaults.autoplay) {
            options = {
                ...options, ...{
                    loop: this.$el.find('.swiper-slide').length > 1,
                    autoplay: {
                        delay: this.defaults.autoplay,
                        disableOnInteraction: false,
                    },
                    on:{
                        init: (sw) => {
                            this.isRemoveSwiperWrapLive();
                            setTimeout(() => {
                                this.isA11yUiSwiper(sw, 'init', 'this.defaults.autoplay');
                            },100);
                        },
                        slideChange: (sw) => {
                            this.isA11yUiSwiper(sw);
                        },
                    }
                }
            };
            /*
            if(isA11yCheck){
                options = {
                    ...options, ...{
                        loop: this.$el.find('.swiper-slide').length > 1,
                        autoplay: {
                            delay: this.defaults.autoplay,
                            disableOnInteraction: false,
                        },
                        on:{
                            init: (sw) => {
                                this.isRemoveSwiperWrapLive();
                                setTimeout(() => {
                                    this.isA11yUiSwiper(sw, 'init', 'this.defaults.autoplay');
                                },100);
                            },
                            slideChange: (sw) => {
                                this.isA11yUiSwiper(sw);
                            },
                        }
                    }
                };
            }else{
                options = {
                    ...options, ...{
                        loop: this.$el.find('.swiper-slide').length > 1,
                        autoplay: {
                            delay: this.defaults.autoplay,
                            disableOnInteraction: false,
                        }
                    }
                };
            }
            */
        }

        // CHPFMTASK-2030 리버스 오토플레이 추가
        if (this.defaults.reverseAutoplay) {
            options = {
                ...options, ...{
                    loop: this.$el.find('.swiper-slide').length > 1,
                    autoplay: {
                        delay: this.defaults.autoplay,
                        reverseDirection: true,
                        disableOnInteraction: false,
                    },
                    on:{
                        init: (sw) => {
                            console.log(sw)
                            this.isRemoveSwiperWrapLive();
                            setTimeout(() => {
                                this.isA11yUiSwiper(sw, 'init', 'this.defaults.autoplay');
                            },100);
                        },
                        slideChange: (sw) => {
                            this.isA11yUiSwiper(sw);
                        },
                    }
                }
            };
        }

        /* TODO - http://localhost:8888/kbank_html_mmk/pbk/html/ofr/PBKOFR0200000100S.html?a11y=a11y?a11y&popup=9
        if (this.defaults.autoplay && !this.defaults.paging && isA11yCheck) {
            options = {
                ...options, ...{
                    on : {
                        afterInit: (sw) => {

                        }
                    },
                    loop: this.$el.find('.swiper-slide').length > 1,
                    autoplay: {
                        delay: this.defaults.autoplay,
                        disableOnInteraction: false,
                    }
                }
            };
        }
        */

        if (this.defaults.name == 'flip') {
            options = {
                ...options, ...{
                    allowTouchMove: false,
                    cubeEffect:{
                        shadow: false,
                    },
                }
            };
        }

        // A11YTASK-46 추가
        if(this.$el.hasClass('chk-swiper') && this.$el.hasClass('card-type-flip') && isA11yCheck){
            !this.$el.find('.swiper-button-next').length &&
            this.$el.append(`<div class="swiper-button-prev" role="button" aria-hidden="false" tabindex="0"></div><div class="swiper-button-next" role="button" aria-hidden="false" tabindex="0"></div>`);
            if (this.$el.find('.swiper-slide').length == 1) {
                this.$el.find('.swiper-button-prev').css('display','none')
                this.$el.find('.swiper-button-next').css('display','none')
                this.$el.find('.swiper-button-prev').attr('aria-hidden','true')
                this.$el.find('.swiper-button-next').attr('aria-hidden','true')
            }

            /*! s: FETASK-a11y page isA11yUiSwiper v.1.0.0 */
            const that = this;
            //a11y시 해당 옵션 추가
            options = {
                ...options, ...{
                    slidesPerView: 1,
                    navigation: {
                        prevEl: this.$el.find('.swiper-button-prev')[0],
                        nextEl: this.$el.find('.swiper-button-next')[0],
                    },
                    on:{
                        beforeInit: (sw) => {
                            that.isRemoveSwiperWrapLive();
                            setTimeout(() => {
                                that?.isA11yUiSwiper(sw, 'init', "this.defaults.nav");
                                if(isA11yCheck){
                                    // $(document).off('click.btnFlip');
                                    $(that.$el).addClass('checkA11y');
                                    const btnFlip = $(that.$el).find('.btn-flip');
                                    btnFlip?.attr('aria-live','polite').removeAttr('title').attr('title',btnFlip?.find('.txt').text());
                                    // // btnFlip?.attr({'title': btnFlip?.find('.txt').text()});
                                    btnFlip?.on('click',(e)=>{
                                        e.preventDefault();
                                        const This = $(e.currentTarget);
                                        This.toggleClass('back');
                                        This.hasClass('back') ? btnToggle(This) : btnToggle(This,'back');
                                    });

                                    function btnToggle(target, value){
                                        let $txt = '', fClass = '', eClass='front';
                                        (value && value === 'back') ? ($txt = '뒷면보기', fClass = 'front', eClass='back') : ($txt = '앞면보기', fClass = 'back', eClass='front');
                                        target.find('.txt')?.text($txt);
                                        target.attr('title',target.find('.txt')?.text());
                                        $(that.$el).find(`.swiper-slide-active .${fClass} img`).removeAttr('aria-hidden');
                                        $(that.$el).find(`.swiper-slide-active .${eClass} img`).attr('aria-hidden','true');
                                        console.log($(that.$el).find(`.swiper-slide-active .${fClass} img`))
                                    }
                                }
                            },100);
                        },
                        slideChangeTransitionStart: (sw) => {
                            that?.isA11yUiSwiper(sw);
                        },
                    }
                },
            };
        }

        // 240104 눌렀을때 자동롤링 제어 추가
        if (this.defaults.pressedStop) {
            const that = this;
            // that.$el[0].addEventListener('touchstart',setAutoplay);
            // that.$el[0].addEventListener('touchend',setAutoplay);

            that.$el.find('*').off('touchstart.aaa').on('touchstart.aaa',(e)=>{
                setAutoplay(e);
            });
            that.$el.find('*').off('touchend.aaa').on('touchend.aaa',(e)=>{
                setAutoplay(e);
            });

            function setAutoplay(e){
                e.preventDefault();
                (e.type == 'touchstart') ? (that.swiper.autoplay.stop(), console.log('autoplay stop!!!!!!!')) : (that.swiper.autoplay.start(), console.log('autoplay start!!!!!!!'))
            }
        }

        // statusExpension

        // [FETASK-1972] 요즘 케뱅 온보딩 팝업 손가락 인터렉션
        if (this.defaults.handAnimate) {
            const that = this;
            let onboardingImg = document.querySelector('.onboarding-img');
            options = {
                ...options, ...{
                    on : {
                        slideChange: () =>{     
                            handAnimate();                
                        }
                    }
                }
            } 
            const handAnimate = () =>{
                if(that.swiper == undefined || onboardingImg == null) return false; 
                onboardingImg.classList.remove('active');
                setTimeout(()=>{onboardingImg.classList.add('active');},700);
            }
        }
        // 2024  홈 개편 발견 탭  스와이퍼 옵션 추가
        if (this.defaults.swiperMap) {
            const that = this;
            const $mapEl = $(`[swiper-map-${this.defaults.swiperMap}]`);
                options = {
                    ...options, ...{
                        on : {
                            init: (sw) =>{
                                setTimeout(() => {
                                    this.isRemoveSwiperWrapLive();
                                    this?.isA11yUiSwiper(sw, 'init', 'this.defaults.autoplay'); // 240809  에러이슈 
                                    if (sw) { 
                                        $mapEl.attr(`swiper-map-${this.defaults.swiperMap}`,sw.realIndex )
                                    }
                                    
                                }, 100);
                            },
                            slideChange: (sw) =>{
                                this.isA11yUiSwiper(sw);
                                if (sw) {
                                    $mapEl.attr(`swiper-map-${this.defaults.swiperMap}`,sw.realIndex)
                                }
                            },
                            transitionStart: ()=>{
                                if (this.$el.closest('.finding-stock').length > 0) {
                                    this.$el.closest('.finding-stock').find('.ui-lottie').data('ui').stop()
                                    this.$el.closest('.finding-stock').find('.ui-lottie').data('ui').play()
                                }
                            }
                        }
                    }
                } 
        }

        if (this.defaults.type == 'cards') {  // 240829 변경
            const that = this;
            const transformIndex = this.$el.attr('data-transform-index') == undefined ? 2 : Number(this.$el.attr('data-transform-index'));
            options = {
                ...options, ...{
                    slidesPerView: isA11yCheck && !$('html').hasClass('pc') ? 1 : this.defaults.slidesPerView ? this.defaults.slidesPerView : 'auto',
                    // centeredSlides: isA11yCheck ? true : false,
                    on : {
                        beforeInit: (sw) => {
                            if(isA11yCheck){
                                that.isRemoveSwiperWrapLive();
                                setTimeout(()=>{
                                    that?.isA11yUiSwiper(sw, 'init', "this.defaults.a11yPaging && this.$el.find('.swiper-slide').length > 1");
                                },100);
                            }
                        },
                        init:(e)=>{
                            setTimeout(()=>{
                                $(e.slides).each((idx,slide)=>{
                                    $(slide).attr('slideIndex', idx);
                                    $(slide).removeClass('type-one')
                                    
                                })
                                if (this.$el.find('.swiper-slide').length == 1) {
                                    this.$el.find('.swiper-slide').addClass('swiper-slide-active type-one')
                                }
                            },50)
                        },
                        slideChange: (sw) => {
                            if(isA11yCheck) that?.isA11yUiSwiper(sw);
                        },
                        sliderMove: (e, sw) =>{
                            if (!this.$el.hasClass('card-active')) {
                                if (this.$el.hasClass('moving-end')) {
                                    this.$el.removeClass('moving-end')
                                }
                                if (e.touches.startX > e.touches.currentX) {
                                    if (!this.$el.hasClass('left-check')) {
                                        this.$el.removeClass('right-check').addClass('left-check')
                                        this.slideRemoveClass('moving-right')
                                        this.inandoutEvent(e,'moving-left',transformIndex);
                                    }
                                } else {
                                    if (!this.$el.hasClass('right-check')) {
                                        this.$el.removeClass('left-check').addClass('right-check')
                                        this.slideRemoveClass('moving-left')
                                        this.inandoutEvent(e,'moving-right',transformIndex);
                                    }
                                }

                            } else {
                                if (this.defaults.touchRatio == 1) {
                                    this.defaults.touchRatio = 0;
                                    this.attachEvents();
                                }
                            }
                        },
                        touchEnd: (e) =>{
                            if (!this.$el.hasClass('moving-end')) {
                                this.$el.removeClass('left-check right-check').addClass('moving-end')
                                this.slideRemoveClass('moving-left moving-right')
                            }
                        }
                    }
                }
            }
        }

        // 2024 홈 개편 혜택 탭 스와이퍼 
        if (this.$el.hasClass('main-bnf-slide')) {
            const that = this;
            options = {
                ...options, ...{
                    on : {
                        slideChange: () =>{
                            setTimeout(()=>{
                                console.log($(that.swiper.$el[0]).find('.swiper-slide-next'))
                                $(that.swiper.$el[0]).find('.swiper-slide-next').addClass('bnf-next-slide')
                            },200)
                        }
                    }
                }
            } 
            
        }

        // [FETASK-1218] 새소식 서비스 타이머 인터렉션
        if (this.defaults.timerStart) {
            const that = this;

            let nTimer = this.defaults.timerSec;
            let toastPopup = null;
            let activeIndex = 0;
            let timeoutEffect;
            let timeoutAlert;   
            let hiddenSlide;
            let startSlide;
            let swiperIndex;
            let chkToast = this.defaults.toastNone;

            // this.defaults.loop = false;
            
            const setTimeEffect = (timer = nTimer) => {
                console.log('타이머 실행...');           
                console.log('nTimer', timer);

                timeoutEffect = setTimeout(() => {                    
                    const activeSlide = that.swiper.el.querySelector('.swiper-slide-active');
                    const ypos = activeSlide.getBoundingClientRect().bottom;
                    activeIndex = that.swiper.activeIndex;
                    console.log(`사용자 동작이 ${timer/1000}초 동안 없습니다!!`);
                    activeSlide.classList.add('inducing');

                    if(that.swiper.realIndex > 0) return false;
                    if(toastPopup) return false;

                    // 토스트팝업 노출
                    if(!chkToast) {
                        showToastPopup(ypos);
                        timeoutAlert = setTimeout(() => {
                            closeToastPopup();
                        }, 2000);   // 2초후 Fade-out
                    }
                }, timer);
            }
            const resetTimeEffect = (timer) => {
                timeoutEffect && clearTimeout(timeoutEffect); // 이전 타이머를 초기화
                timeoutAlert && clearTimeout(timeoutAlert);

                if(timeoutAlert && toastPopup.classList.contains('fade-in')){
                    closeToastPopup();
                }
                
                if(that.swiper == undefined || activeIndex == undefined) return false
                that.swiper.slides[activeIndex].classList.remove('inducing');
                
                setTimeEffect(timer);
            }

            const showToastPopup = (ypos) => {
                const yOffset = ypos - this.el.getBoundingClientRect().top;

                this.$el.append(getCardToastTmpl);
                this.$el.addClass('tooltip-focus-group ui-tooltip');

                toastPopup = this.el.querySelector('.tooltip-area');
                // toastPopup.style.top = `calc(${yOffset}px + 2rem)`;
                setTimeout(() => {
                    toastPopup.classList.add('fade-in');
                }, 100);
            };

            const closeToastPopup = () => {
                toastPopup.classList.remove('fade-in');
                toastPopup.classList.add('fade-out');
            }

            //TODO 카드형 슬라이드 접근성 추가 필요
            /*! s: FETASK-a11y page isA11yUiSwiper v.1.0.0 */
            if(this.defaults.paging){
                options = {
                    ...options, ...{
                        // slidesPerView: isA11yCheck && !$('html').hasClass('pc') ? 1 : this.defaults.slidesPerView ? this.defaults.slidesPerView : 'auto',
                        on : {
                            /*
                            beforeInit: function(){
                                console.log('before init...');
                                // document.querySelector('.onboarding-card.ui-swiper .swiper-slide:last-child').classList.add('hidden');
                            },
                            */
                            beforeInit: (sw) => {
                                console.log('before init...');
                                that.isRemoveSwiperWrapLive();
                                setTimeout(() => {
                                    that?.isA11yCardTypeSwiper(sw, 'init');
                                });
                            },
                            init : function(){
                                setTimeout(() => {
                                    // hiddenSlide = Array.from(that.swiper.slides).filter(slide => slide.classList.contains('hidden'));
                                    that.swiper.pagination.el.classList.add('active');
    
                                    if(that.defaults.callbackfn != null){
                                        that.defaults.callbackfn();
                                    }
                                    console.log('swiper init...');                        
                                }, 100);                                      
                            // setTimeEffect();
                            },
                            slideChange: function(sw){
                                if(that.swiper == undefined) return false;
    
                                console.log('타이머 초기화...');
                                
                                if(startSlide && startSlide.querySelector('.section-link').classList.contains('startslide')){
                                    startSlide.querySelector('.section-link').classList.remove('startslide');
                                    startSlide = null;
                                    nTimer = 15000;
                                }
    
                                resetTimeEffect(nTimer);

                                that?.isA11yCardTypeSwiper(sw);
                            },
                            beforeSlideChangeStart: function(){
                                console.log('beforeSlideChangeStart...');
                                
                                setTimeout(() => {
                                    startSlide = that.swiper.el.querySelector('.swiper-slide-active');
                                    // if(startSlide.querySelector('.section-link').classList.contains('startslide')){
                                    //     that.swiper.allowSlidePrev = false;
                                    // }
    
                                    if(!startSlide) return false;
    
                                    const onStartSlides = that.swiper.el.querySelectorAll('.startslide');
                                    if(!onStartSlides.length){
                                        return false;
                                    }
    
                                    onStartSlides.length && [...onStartSlides].forEach((slide) => {
                                        if(slide == startSlide.querySelector('.section-link')) return;
                                        slide.classList.remove('startslide');
                                    });
    
                                    resetTimeEffect(nTimer);
                                }, 100);
                            },
                            observerUpdate: function(){
                                if(that.swiper){
                                    startSlide = that.swiper.slides[that.swiper.activeIndex];
                                    startSlide && startSlide.querySelector('.section-link').classList.add('startslide');
                                    console.log('observerUpdated...');
                                }
                            },
                            slideChangeTransitionEnd: function(){     
                                if(that.swiper == undefined) return false;
    
                                console.log('slideChangeTransitionEnd...');                        
                            }
                        }
                    }
                }    
            }
            /*
            else{
                //기존 소스
                options = {
                    ...options, ...{
                        on : {
                            beforeInit: function(){
                                console.log('before init...');
                                // document.querySelector('.onboarding-card.ui-swiper .swiper-slide:last-child').classList.add('hidden');
                            },
                            init : function(){
                                setTimeout(() => {
                                    // hiddenSlide = Array.from(that.swiper.slides).filter(slide => slide.classList.contains('hidden'));
                                    that.swiper.pagination.el.classList.add('active');
    
                                    if(that.defaults.callbackfn != null){
                                        that.defaults.callbackfn();
                                    }
                                    console.log('swiper init...');                        
                                }, 100);                                      
                            // setTimeEffect();
                            },
                            slideChange: function(){
                                if(that.swiper == undefined) return false;
    
                                console.log('타이머 초기화...');
                                
                                if(startSlide && startSlide.querySelector('.section-link').classList.contains('startslide')){
                                    startSlide.querySelector('.section-link').classList.remove('startslide');
                                    startSlide = null;
                                    nTimer = 15000;
                                }
    
                                resetTimeEffect(nTimer);
                            },
                            beforeSlideChangeStart: function(){
                                console.log('beforeSlideChangeStart...');
                                
                                setTimeout(() => {
                                    startSlide = that.swiper.el.querySelector('.swiper-slide-active');
                                    // if(startSlide.querySelector('.section-link').classList.contains('startslide')){
                                    //     that.swiper.allowSlidePrev = false;
                                    // }
    
                                    if(!startSlide) return false;
    
                                    const onStartSlides = that.swiper.el.querySelectorAll('.startslide');
                                    if(!onStartSlides.length){
                                        return false;
                                    }
    
                                    onStartSlides.length && [...onStartSlides].forEach((slide) => {
                                        if(slide == startSlide.querySelector('.section-link')) return;
                                        slide.classList.remove('startslide');
                                    });
    
                                    resetTimeEffect(nTimer);
                                }, 100);
                            },
                            observerUpdate: function(){
                                if(that.swiper){
                                    startSlide = that.swiper.slides[that.swiper.activeIndex];
                                    startSlide && startSlide.querySelector('.section-link').classList.add('startslide');
                                    console.log('observerUpdated...');
                                }
                            },
                            slideChangeTransitionEnd: function(){     
                                if(that.swiper == undefined) return false;
    
                                console.log('slideChangeTransitionEnd...');                        
                            }
                        }
                    }
                }    
            }    
            */        
        }
        /*! e: FETASK-a11y page isA11yUiSwiper v.1.0.0 */

        // [FETASK-870] '처음으로 가기' 버튼 추가
        if (this.defaults.shortcutButton) {
            const that = this;
            const index = this.defaults.shortcutIndex?? 2;
            
            options = {
                ...options, ...{
                    on : {
                        init : function(){
                            setTimeout(() => {
                               if(that.swiper.slides.length >= index){
                                    that.swiper.appendSlide([
                                        `<div class="swiper-slide">
                                            <div class="season-food-first">
                                                <a href="#" class="btn-season-food-first">처음으로 가기</a>
                                            </div>
                                        </div>`    
                                    ]);
                                }
                                const firstBtn = that.swiper.el.querySelector('.btn-season-food-first');
                                firstBtn && firstBtn.addEventListener('click', (e) => {
                                    e.preventDefault()
                                    that.swiper.slideTo(0);
                                });
                            }, 0);
                        },
                    }
                }
            }
        }
        if (this.$el.closest('.intro-swipe-wrap').length > 0) { // 240523 홈개편  인트로 스와이프
            const that = this;
            options = {
                ...options, ...{
                    on : {
                        init : function(e){
                            that.$el.closest('.intro-swipe-wrap').find('.intro-swipe-btn .type-next').off('click.homeIntro').on('click.homeIntro', function(){
                                that.swiper.slideTo(that.swiper.activeIndex+1)
                                if (that.swiper.activeIndex  > 1 ) {
                                    $(this).hide()
                                    $(this).next().show().focus();
                                } 
                            })
                        },
                        slideChange : function (e){
                            if (that.swiper.activeIndex > 1) {
                                that.$el.closest('.intro-swipe-wrap').find('.intro-swipe-btn .type-next').hide()
                                that.$el.closest('.intro-swipe-wrap').find('.intro-swipe-btn .type-home').show()
                            }else {
                                that.$el.closest('.intro-swipe-wrap').find('.intro-swipe-btn .type-next').show()
                                that.$el.closest('.intro-swipe-wrap').find('.intro-swipe-btn .type-home').hide()
                            }
                        },
                    }
                }
            }
        }
        if (this.defaults.yyy == 'aaaa') {

        }
        if (this.defaults.type == 'cta') {
            const that = this;
            this.defaults.ctaDefaultText = $(`[cta-button="${this.$el.attr('cta-id')}"] span`).text();
            this.defaults.ctaEndText = this.$el.attr('cta-end-text')

            function setCtAattr(){
                if (that.swiper.realIndex == that.$el.find('.swiper-slide').length - 1) {
                    $(`[cta-button="${that.$el.attr('cta-id')}"] span`).text(that.defaults.ctaEndText);
                    $(`[cta-button="${that.$el.attr('cta-id')}"]`).attr('data-islast','true');
                }else {
                    $(`[cta-button="${that.$el.attr('cta-id')}"] span`).text(that.defaults.ctaDefaultText);
                    $(`[cta-button="${that.$el.attr('cta-id')}"]`).attr('data-islast','false');
                }
            }

            options = {
                ...options, ...{
                    on : {
                        init : function(sw){
                            setTimeout(() => {
                                setCtAattr();
                                frontUI.actionCtaButton(that.swiper.realIndex,that);
                            }, 0);

                            that.isRemoveSwiperWrapLive();
                            setTimeout(() => {
                                that?.isA11yUiSwiper(sw, 'init', "this.defaults.type == 'cta'");
                            },100);
                            /*
                            if(isA11yCheckVersion()){
                                that.isRemoveSwiperWrapLive();
                                setTimeout(() => {
                                    that?.isA11yUiSwiper(sw, 'init', "this.defaults.type == 'cta'");
                                },100);
                            }
                            */
                        },
                        /*! s: FETASK-a11y page isA11yUiSwiper v.1.0.0 */
                        slideChange : function (e){
                            setCtAattr();
                            frontUI.actionCtaButton(that.swiper.realIndex,that);

                            that?.isA11yUiSwiper(e);
                        },
                        /*
                        slideChangeTransitionStart: (sw) => {
                            that?.isA11yUiSwiper(sw);
                        }
                        */
                        /*! e: FETASK-a11y page isA11yUiSwiper v.1.0.0 */
                    }
                }
            };
        }
        if (this.defaults.scrollAction) { // CHPFMTASK-958
            this.pause();
        }
        if (this.defaults.callback) {
            const that = this;
            options = {
                ...options, ...{
                    on : {
                        init : function(){
                            if (this.$el.hasClass('meetchallenge-swiper')) {
                                setTimeout(() => {
                                    that.FPMDPT2100000300S(that.$el, that.swiper.realIndex)
                                }, 150);
                            }
                        },
                        slideChange : function (e){
                            if (e.realIndex === 1 &&  this.$el.find('[data-calcAni]').length > 0) {
                                frontUI.calcAnimation();
                            }
                            if (that.defaults.pagingAnimation === 'fill') {
                                that.$el.find('.swiper-pagination-bullet').each( (idx, indi) => {
                                    if (idx < that.swiper.realIndex) {
                                        $(indi).addClass('filled');
                                    } else if (idx === that.swiper.realIndex) {
                                        $(indi).removeClass('filled')
                                    } else {
                                        $(indi).removeClass('filled');
                                    }
                                });
                            }
                            if (this.$el.hasClass('meetchallenge-swiper')) {
                                setTimeout(() => {
                                    that.FPMDPT2100000300S(that.$el, that.swiper.realIndex)
                                }, 150);
                            }
                        },
                        paginationRender: function(s, el) {
                            if (that.defaults.pagingAnimation === 'fill') {
                                const aniTime = Number(that.defaults.autoplay) * 0.001;
                                $(el).find('.swiper-pagination-bullet').append(`<span class="fill-item" style="animation-duration: ${aniTime}s;"></span>`);
                            }
                        }
                    }
                }
            }
        }

        /*! s: FETASK-a11y page isA11yUiSwiper v.1.0.0 */
        if (this.defaults.callback && this.defaults.pagingAnimation === 'fill') {
            //이모지 슬라이드 접근성 추가
            const that = this;
            options = {
                ...options, ...{
                    on : {
                        afterInit: (sw) => {
                            that.isRemoveSwiperWrapLive();
                            setTimeout(() => {
                                that.isA11yUiSwiper(sw,'init', "this.defaults.callback && this.defaults.pagingAnimation === 'fill'");
                            },500);
                        },
                        slideChange : function (e){
                            that.$el.find('.swiper-pagination-bullet').each( (idx, indi) => {
                                if (that.swiper != null) { // a11y 추가이후  에러 수정 240507
                                    if (idx < that.swiper.realIndex) {
                                        $(indi).addClass('filled');
                                    } else if (idx === that.swiper.realIndex) {
                                        $(indi).removeClass('filled')
                                    } else {
                                        $(indi).removeClass('filled');
                                    }
                                }
                                
                            });
                            
                            that.isA11yUiSwiper(e);
                        },
                        paginationRender: function(s, el) {
                            const aniTime = Number(that.defaults.autoplay) * 0.001;
                            $(el).find('.swiper-pagination-bullet').append(`<span class="fill-item" style="animation-duration: ${aniTime}s;"></span>`);
                        },
                        /*
                        slideChangeTransitionStart: (sw) =>{
                            that.isA11yUiSwiper(sw);
                        }
                        */
                    }
                }
            }
        }
        /*! e: FETASK-a11y page isA11yUiSwiper v.1.0.0 */
        
        // 정적 ui-bottom 팝업 내부의 .ui-swiper 실행 (select팝업과 동일한 디자인)
        if(this.$el.hasClass('carousel-select-group')) {
            options = {
                ...options,
                spaceBetween: 0,
                direction: 'vertical',
                freeMode: true,
                allowTouchMove: false,
            }
        }

        // tab 연동되는 swiper
        if(this.$el.attr('slide-tab-list')) {
            const name = this.$el.attr('slide-tab-list');
            const that = this;
            options = {
                ...options, ...{
                    on : {
                        afterInit: (sw) =>{
                            /*! s: FETASK-a11y page isA11yTabItems,isA11yUiSwiper v.1.0.0 */
                            if(isA11yCheck){
                                that.isRemoveSwiperWrapLive();
                                setTimeout(() => {
                                    //that.isA11yTabItems(name, sw);
                                    frontUI.tabSlide(name, sw.realIndex);
                                    that.isA11yUiSwiper(sw, 'init', "this.$el.attr('slide-tab-list')");
                                },100);
                            }
                            /*! e: FETASK-a11y page isA11yTabItems,isA11yUiSwiper v.1.0.0 */
                        },
                        slideChange : function (e){
                            frontUI.tabSlide(name,this.activeIndex);
                            if ($(`[slide-tab-nav="${name}"]`).find('.tabline').length > 0) {
                                let $tabNav = $(`[slide-tab-nav="${name}"]`);
                                if ($tabNav.attr('scrollposition') != undefined) {
                                    let tabArr = $tabNav.attr('scrollposition').split(',');
                                    tabArr[this.previousIndex] = $tabNav.closest('.ui-kbank-page-control').find('.page-inner-scroll').scrollTop();
                                    $tabNav.closest('.ui-kbank-page-control').find('.page-inner-scroll').scrollTop(tabArr[this.activeIndex]);
                                    $tabNav.attr('scrollposition' , tabArr);
                                    var left
                                    if ($tabNav.find('.active').offset().left + $tabNav.find('.active').width() > $tabNav.width() / 1.8) {
                                        left = $tabNav.find('.tab-item:last').offset().left+$tabNav.find('.active').width()+ $tabNav.scrollLeft();
                                        $tabNav.animate({scrollLeft: left},300);
                                    } else {
                                        $tabNav.animate({scrollLeft: 0},300);
                                    }
                                    frontUI.tabScrollnavLine(name);
                                }
                            }
                            if (that.defaults.callbackfn != null) {
                                frontUI.prdtSlideChange(that.defaults.callbackfn);
                            }
                            frontUI.swiperHeightCheck(name,this.activeIndex)
                            //메인홈 상품 Tab영역 a11y TODO
                            /*! s: FETASK-a11y page isA11yTabItems,isA11yUiSwiper v.1.0.0 */
                            if(isA11yCheck){
                                //that.isA11yTabItems(name,e);
                                that.isA11yUiSwiper(e);
                            }
                            /*! e: FETASK-a11y page isA11yTabItems,isA11yUiSwiper v.1.0.0 */
                        },
                        /*
                        slideChangeTransitionStart: function(e){
                            if(isA11yCheck){
                                that.isA11yTabItems(name,e);
                                that.isA11yUiSwiper(e);
                            }
                        }
                        */
                    }
                }
            }
        }

        // s: 개별 이벤트 실행 2023-01-11
        if(this.defaults.eventName) {
            if (this.defaults.eventName == 'numBannerAni') {
                options = this.numBannerAni(options);
            }
        }
        // e: 개별 이벤트 실행
        setTimeout(() => {
            if(!this.$el.find('.swiper-container')[0]){
                return;
            }
            if(!this.$el.find('.swiper-container .swiper-wrapper')[0]){
                return;
            }
            if(!this.$el.find('.swiper-container .swiper-wrapper .swiper-slide')[0]){
                return;
            }

            if(!this.swiper){
                this.swiper = new Swiper(this.$el.find('.swiper-container')[0], options);
                if (this.swiper.params.loop) {
                    this.swiper.slideToLoop(options.initialSlide)
                } else {
                    this.swiper.slideTo(options.initialSlide)
                }
            }
        }, 0);

        /*! s: FETASK-a11y page isA11yTrnCarousel v.1.0.0 */
        /*
        if(isA11yCheck){
            this.isRemoveSwiperWrapLive();
            isA11yTrnCarousel();
            isA11yCarouselSelect(document);
        }
        */
        this.isRemoveSwiperWrapLive();
        isA11yTrnCarousel();
        isA11yCarouselSelect(document);
        /*! e: FETASK-a11y page isA11yTrnCarousel v.1.0.0 */

        //보험 슬라이드 1개일때 페이지 네이션 생성되고 swiper 인스턴스 생성 제거
        if(this.defaults.paging && this.$el.find('.swiper-slide').length == 1){
            $(document).ready(() => {
                this.$el?.data('ui')?.swiper?.destroy();
                this.$el?.find('.swiper-pagination')?.remove();
            });
        }

        //슬라이드 1개이거나 1개이하이고 페이지 네이션 없을때 swiper 인스턴스 생성 제거
        if(!this.defaults.paging && this.$el.find('.swiper-slide').length <= 1){
            $(document).ready(() => {
                this.$el?.data('ui')?.swiper?.destroy();
            });
        }

        // CHPFMTASK-1658 : 초기 dimm 깔리고  동작 막음
        if(this.defaults.type == 'dimm' && this.$el.find('.swiper-slide').length > 1){
            setTimeout(()=>{
                if (this.$el.find('[data-slide-dimm="false"]').length > 0) {
                    this.$el.find('[data-slide-dimm="false"]').each((i,e)=>{
                        $(e).attr('data-slide-dimm', true)
                    })
                }
                this.$el.data('ui').swiper.allowTouchMove = false
                this.$el.data('ui').swiper.pagination.destroy();
            },1)
        }
    }
    // 내부함수
    open() {

    }
    // 내부함수
    close() {

    }
    /**
     * swiper slide 비동기적으로 불러왔을경우 재실행
     * @example 
     * $('.ui-swiper').data('ui').update();
     */
    update(){
        setTimeout(() => {
            this.destroy();
            this.attachEvents();
            // CHPFMTASK-1658 (dimm 삭제,pagination 초기화)
            if(this.defaults.type == 'dimm' && this.$el.find('.swiper-slide').length > 1){
                const thisEl =  this.$el;
                
                if(thisEl.find('.swiper-slide').length > 1){
                    if (this.defaults.paging) {        
                        setTimeout(()=>{
                            thisEl.find('[data-slide-dimm="true"]').attr('data-slide-dimm', false);
                            thisEl.data('ui').swiper.allowTouchMove = true;
                            thisEl.data('ui').swiper.pagination.update();
                            thisEl.data('ui').swiper.pagination.init();
                        },2)
                    }
                    // if (thisEl.attr('data-card-flip')) {
                    //     thisEl.data('ui').swiper.allowTouchMove = isA11yCheckVersion() ? false : true;
                    // }
                }else{
                    setTimeout(()=>{
                        thisEl.find('[data-slide-dimm="true"]').attr('data-slide-dimm', true);
                        thisEl.data('ui').swiper.allowTouchMove = false;
                        thisEl.data('ui').swiper.pagination.destroy();
                    },2)
                    
                }
            }
        });
    }
    // 내부함수
    cardsUpdate(){
        this.destroy();
        setTimeout(() => {
            this.attachEvents();
        });
    }
    // 내부함수
    changeCallbackFn(callback) { // 사용안하는거 같음
        if (callback && $.isFunction(callback)){
            this.defaults.callbackfn = callback;
        }
    }
    /**
     * swiper change 이벤트 콜백 
     * @param {function} callback    swiper change 이후 콜백 함수
     * @param {Selector} ctx  사용하는곳 확인 필요
     * @example 
     * $('.ui-swiper').data('ui').changeCallback();
     */
    changeCallback(callback, ctx) {
        const that = ctx != undefined ? ctx : this;

        that.defaults.callbackfn = callback;
        if ($.isFunction(callback)) {
            that.swiper && that.swiper.on('slideChange', callback);
        } 
    }
    // 내부함수
    detachEvents() {
        this.$el.off(this.eventId);
    }
    // 내부함수
    destroy() {
        this.detachEvents();
        this.swiper && this.swiper.destroy();
        this.swiper = null;
    }
    /**
     * swiper auto case 경우 멈춤 이벤트
     * @example 
     * $('.ui-swiper').data('ui').pause();
     */
    pause() { // CHPFMTASK-958
        setTimeout(()=>{
            this.detachEvents();
            this.swiper.autoplay.pause()
        },5)
    }
    /**
     * swiper auto case 경우 재동작 이벤트
     * @example 
     * $('.ui-swiper').data('ui').run();
     */
    run() { // CHPFMTASK-958
        this.attachEvents();
        this.swiper.slideTo(this.swiper.activeIndex+1)
        this.swiper.autoplay.run()
    }

    start(){ // CHPFMTASK-2275 오토플레이 다시 시작
        this.swiper.slideToLoop(0,0);
    }

    // 내부함수
    slideRemoveClass (_class) { // 240828 inandout 슬라이드
        for (var i = 0; i < this.swiper.slides.length; i++) {
            this.$el.find('.swiper-slide').eq(i).removeClass(_class)
        }
    }
    // 내부함수
    inandoutEvent (_swiper,type, index) { // 240828 inandout용 이벤트
        for (var i = 0; i <= index; i++) {
            $(this.swiper.slides[this.swiper.activeIndex - i])?.addClass(type)
            $(this.swiper.slides[this.swiper.activeIndex + i])?.addClass(type)
        }
    }
    // s: FETASK-877 | 슬라이드 및 애니메이션 스크립트 (FPMDPT2100000300S 전용) - 내부함수
    FPMDPT2100000300S(swiperCont,activeIndex){
        swiperCont.find('[data-role="animation-item"]').each(function(){
            if ($(this).closest('.swiper-slide').hasClass('swiper-slide-active')) {
                $(this).addClass('active')
            } else{
                $(this).removeClass('active')
                swiperCont.find('.graph-group .txt-box .txt1').removeClass('end')
            }
        })
    }
    // e: FETASK-877 | 슬라이드 및 애니메이션 스크립트


    // s: 슬라이드 및 숫자 애니메이션 스크립트 (PBKINQ2300000000S, FPMDPT2100000300S) - 내부함수
    numBannerAni(options) {
        const that = this;
        const maxAmount = 4000000; // 최대 금액
        const targetAmount = 4000000; // 애니메이션 목표 금액
        const defaultValue = 100000; // 초기 설정 금액
        let confettiObj;
        let animationBox;
    
        const animateOpt = {
            target: ".ani-num-obj",
            minMax: [0, maxAmount],
            defaultValue: defaultValue,
            comma: true,
            progressBar: ".ani-bar-obj",
            on: {
                valueChanged: (v, obj) => {
                    if (that.defaults.eventType == 'moim') {
                        if (v === maxAmount){
                            setTimeout(()=>{
                                $(animateOpt.target).closest('.txt1').addClass('end')
                            },100)
                            
                        }
                    } else{
                        // 폭죽 실행
                        if (v === maxAmount){
                            var topPos = $(".confetti-wrap.swiper-slide-active .meet-animation-box04").position().top;
                            confettiObj = frontUI.Confetti(".swiper-slide-active.confetti-wrap", {
                                top: topPos, count: 72, velocity: 12, size: [8, 14]
                            });
                        }
                    }
                }
            }
        };

        // const animationBox = new frontUI.AnimateProgress(animateOpt);
        // setTimeout(function(){ // FETASK-1320 | 230818 : 슬라이드 3 -> 1 순서로 바뀌면서추가
        //     console.log(1111)
        //     animationBox.animate(targetAmount); // 목표 금액 셋팅
        // }, 200);
        options.on = Object.assign(options.on, {
            // beforeSlideChangeStart: function({realIndex}){
            //     console.log('start')
            //     setTimeout(function(){
            //         animationBox.animate(targetAmount); // 목표 금액 셋팅
            //     }, 2000);
            // },
            init : function(){
                setTimeout(() => {
                    animateOpt.target = document.querySelectorAll('.ani-num-obj');
                    animateOpt.progressBar = document.querySelectorAll('.ani-bar-obj');
                    animationBox = new frontUI.AnimateProgress(animateOpt);
                }, 100);                                      
            },
            slideChangeTransitionEnd: function({realIndex}) {
                let activeIdx = 3;
                let timer = 200
                if (that.defaults.eventType == 'moim') {
                    activeIdx = 0;
                    timer = 1500
                }
                if (realIndex == activeIdx) {
                    setTimeout(function(){
                        animationBox.animate(targetAmount); // 목표 금액 셋팅
                    }, timer);
                } else {
                    setTimeout(function(){
                        animationBox.reset(); // 기존 상태로 초기화
                    }, timer);
                    confettiObj?.terminate();
                    confettiObj = null;
                }
            }
        });

        return options;
    }
    // e: 슬라이드 및 숫자 애니메이션 스크립트
    //CHPFMTASK-1658 : 초기 dimm 깔리고  동작 막은거 재기동
    
    /*! s: FETASK-a11y page isA11yUiSwiper v.1.0.0 - 내부함수 */
    async isA11yUiSwiper(sw, type="default", isSwiperType=""){
        //isSwiperType => this.default 타입 종류 디버깅 편의
        if(sw && !sw?.destroyed){
            const isType = type;
            $(document).ready(() => {
                try {
                    if(isA11yCheckVersion()) {
                        const { $el, $wrapperEl, slides , activeIndex, realIndex} = sw;

                        if(!$el || !$wrapperEl || !slides) return; //sw undefined대응
    
                        const btnsDisabled = document?.querySelectorAll('.swiper-button-next[aria-disabled="false"], .swiper-button-prev[aria-disabled="false"]');
            
                        if(btnsDisabled){
                            btnsDisabled?.forEach((list) => {
                                list.removeAttribute('aria-disabled');
                            });
                        }
                        
                        $($wrapperEl)?.removeAttr('aria-live');
    
                        // 접근성 모드일때 a11y-swiper 클래스 추가
                        $($el).closest('.ui-swiper').addClass('a11y-swiper');
    
                        //현재 active된 곳만 focus이동
                        Array?.from(slides)?.length && Array.from(slides)?.forEach((list) => {
                            const linkEle = list?.querySelector('a');
                            const imgEle = list?.querySelector('img');
                            const cardSpanEle = list?.querySelector('.card-name-top span');
                            const cardMidEle = list?.querySelector('.card-name-mid');

                            list?.setAttribute('aria-hidden', 'true');
                            list?.setAttribute('tabindex', '-1');
                            list?.removeAttribute('role');
                            list?.removeAttribute('aria-label');
    
                            $(list).find('*').attr('aria-hidden','true');
    
                            if(linkEle){
                                linkEle?.setAttribute('aria-hidden', 'true');
                                linkEle?.setAttribute('tabindex', '-1');
                            }
                            if(imgEle){
                                imgEle?.setAttribute('aria-hidden', 'true');
                            }
            
                            if(cardSpanEle){
                                cardSpanEle?.setAttribute('aria-hidden', 'true');
                            }
            
                            if(cardMidEle){
                                cardMidEle?.setAttribute('aria-hidden', 'true');
                            }
                        });
    
                        $('.swiper-button-prev')
                            .attr('aria-label','이전')
                            .removeAttr('aria-disabled');
                            
                        $('.swiper-button-next')
                            .attr('aria-label','다음')
                            .removeAttr('aria-disabled');
    
                        $('.swiper-button-disabled').attr('aria-disabled','true');
    
                        $(slides[activeIndex])?.find('*').removeAttr('aria-hidden');

                        // CHPFMTASK-2218 .payment-step-group 요소가 있으면 aria-hidden : true
                        const paymentStepGroup = $(slides[activeIndex])?.find('.payment-step-group');
                        if(paymentStepGroup.length > 0){
                            paymentStepGroup.attr('aria-hidden','true');
                            paymentStepGroup.find('*').attr('aria-hidden','true');
                        }
    
                        const activeLinkEle = slides[activeIndex]?.querySelector('a');
                        const activeImgEle = slides[activeIndex]?.querySelector('img');
                        const activeCardSpanEle = slides[activeIndex]?.querySelector('.card-name-top span');
                        const activeCardMidEle = slides[activeIndex]?.querySelector('.card-name-mid');
            
                        slides[activeIndex]?.removeAttribute('aria-hidden');
                        slides[activeIndex]?.removeAttribute('tabindex');
                        slides[activeIndex]?.removeAttribute('aria-label');
    
                        // data-a11y-view PC 접근성 대응용 속성 추가 A11YTASK-536, A11YTASK-541, A11YTASK-542)
                        const getA11yview = Number($($el).closest('.ui-swiper').attr('data-a11y-view'));
                        if(getA11yview && $('html').hasClass('pc')){
                            const setA11yview = (getA11yview - 1) / 2;
                            setTimeout(()=>{
                                chkView('prev');
                                chkView('next');
                            })
                            function chkView(value){
                                for(let i=1; i<= setA11yview; i++){
                                    const setIndex = value === 'next' ? activeIndex + i : activeIndex - i; 
                                    $(slides[setIndex])?.removeAttr('aria-hidden tabindex');
                                    $(slides[setIndex])?.find('*').removeAttr('aria-hidden tabindex');
                                }
                            }
                        }
    
                        if(activeLinkEle){
                            activeLinkEle?.removeAttribute('aria-hidden');
                            activeLinkEle?.removeAttribute('tabindex');
                        }
            
                        if(activeImgEle){
                            activeImgEle?.removeAttribute('aria-hidden');
                            activeImgEle?.removeAttribute('tabindex');
                        }
            
                        if(activeCardSpanEle){
                            activeCardSpanEle?.removeAttribute('aria-hidden');
                            activeCardSpanEle?.removeAttribute('tabindex');
                        }
            
                        if(activeCardMidEle){
                            activeCardMidEle?.removeAttribute('aria-hidden');
                            activeCardMidEle?.removeAttribute('tabindex');
                        }
        
                        const activeGuidEle = slides[activeIndex]?.querySelector('.document-guide-group');
                        const activeGuidImgEle = slides[activeIndex]?.querySelector('.guide-img');
                        const activeGuidTextEle = slides[activeIndex]?.querySelector('.guide-txt');
        
                        if(activeGuidEle){
                            activeGuidEle?.removeAttribute('aria-hidden');
                            activeGuidEle?.removeAttribute('tabindex');
                        }
        
                        if(activeGuidImgEle){
                            activeGuidImgEle?.removeAttribute('aria-hidden');
                            activeGuidImgEle?.removeAttribute('tabindex');
                        }
        
                        if(activeGuidTextEle){
                            activeGuidTextEle?.removeAttribute('aria-hidden');
                            activeGuidTextEle?.removeAttribute('tabindex');
                        }
    
                        //console.log(sw.pagination.bullets);
                        //console.log('page', sw.pagination.el);
                        //console.log('pagingChild', $(sw.pagination.el).find('span'));
                        
                        const paginationEles = $el[0]?.parentElement?.querySelector('.swiper-pagination') || sw?.pagination?.bullets;
                        const pagingChilds = $el[0]?.parentElement?.querySelectorAll('.swiper-pagination span');
                        
        
                        const totalNodes = pagingChilds?.length && Array.from(pagingChilds)?.map((item) => {
                            if(item.tagName !== 'DIV') {
                                return item;
                            }
                        });
                        const isFraction = paginationEles && paginationEles?.classList.contains('swiper-pagination-fraction');
                        const totalLength = totalNodes?.length || 0;
                        
    
                        pagingChilds && Array.from(pagingChilds)?.length && Array.from(pagingChilds)?.forEach((list,idx) => {
                            list?.setAttribute('role', 'button');
                            list?.setAttribute('tabindex','0');
                            
                            if(list.tagName === 'DIV') return;
        
                            if(isFraction){
                                //swiper-pagination-fraction 일때
                                if(idx !== realIndex){
                                    list?.setAttribute('aria-label',`총${totalLength}슬라이드`);
                                }else{
                                    list?.setAttribute('aria-label',`${totalLength}슬라이드 중 ${idx + 1}슬라이드 선택됨`);
                                }
                            }else{
                                if(idx !== realIndex){
                                    //console.log('list', list)
                                    list?.setAttribute('aria-label',`총${totalLength}개 슬라이드 중 ${idx + 1}번째`);
                                }else{
                                    list?.setAttribute('aria-label',`총${totalLength}개 슬라이드 중 ${idx + 1}번째 선택됨`);
                                    
                                }
                            }
                        });
            
                        //pagingtype fraction 적용
                        const fractionEles = $el[0]?.parentElement?.querySelectorAll('.swiper-container .swiper-wrapper .swiper-slide');
                        const fractionPageEles = $el[0]?.parentElement?.querySelectorAll('.swiper-pagination-fraction');
                        const fractionTotal = $($el[0]?.parentElement)?.find('.swiper-pagination-total');
                        const cardTotalLength = $($el[0])?.find('.swiper-slide:not(.swiper-slide-duplicate)').length;
                        if(fractionEles){
                            Array.from(fractionEles)?.length && Array.from(fractionEles)?.forEach((list, idx) => {
                                const prevEles = $(list).find('a, button, input, textarea, select');
            
                                if(prevEles){
                                    if(idx === activeIndex){
                                        //active slide focus
                                        list.removeAttribute('aria-hidden');
                                        prevEles.removeAttr('aria-hidden');
                                        prevEles.removeAttr('tabindex');
                                        // A11YTASK-449 접근성 추가
                                        if(list.closest('.checkA11y')){
                                            const btnFlip = $(list.closest('.checkA11y').querySelector('.btn-flip'));
                                            if(btnFlip.length > 0){
                                                list.querySelector('.front img')?.removeAttribute('aria-hidden');
                                                list.querySelector('.back img')?.setAttribute('aria-hidden','true');
                                                btnFlip.find('.txt')?.text('뒷면보기');
                                                btnFlip.attr('title',btnFlip.find('.txt')?.text()).removeClass('back');
                                            }
                                        }
                                    }else{
                                        // 나머지요소 focus막기
                                        list.setAttribute('aria-hidden','true');
                                        prevEles.attr({'aria-hidden':'true', 'tabindex':'-1'});
                                    }
                                }
                            });
                        }
        
                        if(fractionPageEles){
                            //console.log('fractionPageEles', fractionPageEles)
                            $(fractionPageEles).children().each((idx, item) => {
                                if($(item).hasClass('swiper-pagination-current')){
                                    $(item).attr('aria-label', `총${fractionTotal.text()} 슬라이드 중 ${$(item).text()} 선택됨`);
                                }
        
                                if($(item).hasClass('swiper-pagination-total')){
                                    $(item).attr('aria-label', `총${fractionTotal.text()} 슬라이드`);
                                }
                            })
                        }

                        const flip = $(slides[activeIndex]).find( ".flip" );
                        if( flip[0] && flip.closest(".one_checkcard-swiper-flip" )[0]){
                            const back = flip.find( ".back" );
                            back[0] && back.attr( 'aria-hidden', 'true' );
                        }
                    }
                    
                    //auto play시 접근성 재생/멈춤 버튼 분기처리 작업
                    isType === 'init' && this.isA11yAutoPlayAccess(sw);
                } catch (error) {
                    throw new Error(`isA11yUiSwiper ${error}`)
                }
            });
        }
    }
    /*! e: FETASK-a11y page isA11yUiSwiper v.1.0.0 */

    /*! s: FETASK-a11y page isA11yTabItems v.1.0.0 - 내부함수 */
    isA11yTabItems(name=null, sw){
        try {
            $(document).ready(() => {
                if(!isA11yCheckVersion()) return;
                const { realIndex } = sw;

                const tabWrap = $(`[slide-tab-nav="${name}"`)[0];
    
                if(tabWrap){
                    const tabItems = tabWrap?.querySelectorAll('li');
    
                    tabItems && tabItems?.forEach((list, idx) => {
                        const linkEle = list?.querySelector('.tab-link');
                        const hideTextEle = list?.querySelector('.hide-txt');
        
                        list?.setAttribute('role','presentation none');
        
                        linkEle?.setAttribute('aria-selected', idx === realIndex); //active일때
        
                        hideTextEle?.setAttribute('aria-hidden','true');
                    });  
                } 
            });
        } catch (error) {
            throw new Error(`isA11yTabItems ${error}`);
        }
    }
    /*! e: FETASK-a11y page isA11yTabItems v.1.0.0 */
    // 내부함수
    isA11yCardTypeSwiper(sw, type="default"){
        if(!sw) return;

        const isType = type;

        try {
            if(isA11yCheckVersion()) {
                const { $el, slides , activeIndex, realIndex, imagesLoaded, imagesToLoad, loopedSlides} = sw;

                const swiperWrap = $($el)?.closest('.ui-swiper');
    
                const isCheckOnboarding = swiperWrap?.find('.txt-card-name')[0];
    
                // console.log('카드스와이퍼') arden

                // 접근성 모드일때 a11y-swiper 클래스 추가
                $($el).closest('.ui-swiper').addClass('a11y-swiper');

                if(isCheckOnboarding){
                    //카드 신청
                    const initImgArr = Array.from(imagesToLoad).splice(0, loopedSlides).map((img) => {
                        const isImgTextLenCheck = img?.alt.length >= 15; //15글자 넘을시 고정텍스트 alt적용
        
                        return isImgTextLenCheck ? '이 카드 디자인을 선택 할께요.' : `${img?.alt}`;
                    });
        
                    $el[0]?.setAttribute('aria-hidden','true');
        
                    $($el[0])?.find('*').attr('tabindex','-1'); //PC 탭 이동 막기용
        
                    const onboardingWrap = document?.querySelector('.onboarding-card .txt-card-name');
        
                    if(onboardingWrap){
                        onboardingWrap.textContent = initImgArr[realIndex];
                    }
        
                    const bottomBtnEle = $el[0]?.parentElement?.parentElement?.parentElement.parentElement.querySelector('.component-btn .btn-group .txt');
                    
                    if(bottomBtnEle){
                        bottomBtnEle.textContent = `${initImgArr[realIndex]} 선택`;
                    }
        
                    const paginationEles = $el[0]?.parentElement?.querySelector('.swiper-pagination');
                    const pagingChilds = paginationEles?.children;
        
                    if(!pagingChilds) return;
        
                    Array.from(pagingChilds)?.length && Array.from(pagingChilds)?.forEach((list,idx) => {
                        list?.setAttribute('role', 'button');
                        list?.setAttribute('tabindex','0');
                        
                        if(idx !== realIndex){
                            list?.setAttribute('aria-label',`${initImgArr[idx]}`);
                        }else{
                            list?.setAttribute('aria-label',`${initImgArr[idx]} 선택됨`);
                        }
                    });
                }else{
                    // 카드선택 외 슬라이드
                    console.log('카드선택 외 슬라이드');
    
                    // 구소스 개인PC 접근성 관련 수정 (A11YTASK-536, A11YTASK-541, A11YTASK-542)
                    $(slides).removeAttr('aria-label');
                    $(slides).attr({'aria-hidden':'true','tabindex':'-1'});
                    $(slides).find('*').attr({'aria-hidden':'true','tabindex':'-1'});

                    if($('html').hasClass('pc')){
                        // data-a11y-view PC 접근성 대응용 속성 추가 A11YTASK-536, A11YTASK-541, A11YTASK-542)
                        const getA11yview = Number($($el).closest('.ui-swiper').attr('data-a11y-view'));
                        if(getA11yview){
                            const setA11yview = (getA11yview - 1) / 2;

                            $(slides).eq(activeIndex).removeAttr('aria-hidden tabindex');
                            $(slides).eq(activeIndex).find('*').removeAttr('aria-hidden tabindex');
    
                            setTimeout(()=>{
                                chkView('prev');
                                chkView('next');
                            })
                            function chkView(value){
                                for(let i=1; i<= setA11yview; i++){
                                    const setIndex = value === 'next' ? activeIndex + i : activeIndex - i; 
                                    console.log('카드형 뷰있음!!!!!!!!!!!', $(slides[setIndex]))
                                    $(slides[setIndex])?.removeAttr('aria-hidden tabindex');
                                    $(slides[setIndex])?.find('*').removeAttr('aria-hidden tabindex');
                                }
                            }
                        }else{
                            $(slides).eq(activeIndex).removeAttr('aria-hidden tabindex');
                            $(slides).eq(activeIndex).find('*').removeAttr('aria-hidden tabindex');
                            
                            $(slides).eq(activeIndex - 1).removeAttr('aria-hidden tabindex');
                            $(slides).eq(activeIndex - 1).find('*').removeAttr('aria-hidden tabindex');
                            
                            $(slides).eq(activeIndex + 1).removeAttr('aria-hidden tabindex');
                            $(slides).eq(activeIndex + 1).find('*').removeAttr('aria-hidden tabindex');
                        }
                    }else{
                        $(slides).eq(activeIndex).removeAttr('aria-hidden tabindex');
                        $(slides).eq(activeIndex).find('*').removeAttr('aria-hidden tabindex');
                    }
                    
                    
    
                    const pageEles = $(sw.pagination.el)?.find('span');
                    const nonLoopLen = Array.from(imagesToLoad).splice(0, loopedSlides)?.length;
                    pageEles?.removeAttr('aria-label');
                    pageEles?.each((idx, item) => {
                        if(idx == realIndex){
                            $(item).attr({'role':'button', 'tabindex':'0', 'aria-label':`총 ${nonLoopLen}개 슬라이드중 중 ${realIndex + 1}번째 선택됨`});
                        }else{
                            $(item).attr({'role':'button', 'tabindex':'0', 'aria-label':`총 ${nonLoopLen}개 슬라이드중 중 ${idx + 1}번째`})
                        }
                        // if(idx == realIndex){
                        //     $(item).attr('aria-label', `총 ${nonLoopLen}개 슬라이드중 중 ${realIndex + 1}번째 선택됨`);
                        // }else{
                        //     $(item).attr('aria-label', `총 ${nonLoopLen}개 슬라이드중 중 ${idx + 1}번째`)
                        // }
                    });
                }
            }
            
            //auto play시 접근성 재생/멈춤 버튼 분기처리 작업
            isType === 'init' && this.isA11yAutoPlayAccess(sw);
        } catch (error) {
            throw new Error(`isA11yCardTypeSwiper ${error}`)
        }
    }
    // 내부함수
    isA11ySwipePrevNextButton(sw){
        try {
            if(!isA11yCheckVersion()) return;
            const swipe = sw;
                                        
            const { previousIndex , activeIndex, $wrapperEl, $el, slides } = swipe;
            const depth = $($el).index();
            const buttonBox = $wrapperEl[0].parentElement;
            const buttons = buttonBox.querySelectorAll('.control-btn');
            const maxLength = $wrapperEl[0].children?.length;

            const selectText = slides[activeIndex].innerText;

            if(activeIndex === 0){
                buttons[0]?.setAttribute('aria-disabled', 'true');
            }else{
                buttons[0]?.removeAttribute('aria-disabled');
            }

            if(activeIndex === maxLength -1){
                buttons[1]?.setAttribute('aria-disabled', 'true');
            }else{
                buttons[1]?.removeAttribute('aria-disabled');
            }

            buttons[0]?.setAttribute('aria-label', `${selectText}, 이전 (감소 버튼)`);
            buttons[1]?.setAttribute('aria-label', `${selectText}, 다음 (증가 버튼)`);
        } catch (error) {
            throw new Error(`func isA11ySwipePrevNextButton ${error}`);
        }
    }
    // 내부함수
    isA11yAddInputArea(sw, type='init'){
        try {
            if(!isA11yCheckVersion()) return;
            const {slides, activeIndex, $el, $wrapperEl} = sw;
            
            slides.forEach((item)=> item.setAttribute('aria-selected', 'false'));
            slides[activeIndex]?.setAttribute('aria-selected', 'true');

            let currentText = '';
            const activeItems = document.querySelectorAll('.activePopup .swiper-slide-active');

            activeItems?.forEach((list) => {
                currentText += list.innerText;
            });

            if(type === 'change'){
                setTimeout(() => {
                    const selectDiv = document?.querySelector('.spinner-live');

                    const createText = document?.createElement('div');
                    createText.innerText = `${currentText} 선택`;
                    
                    $(selectDiv)?.children().remove();

                    selectDiv && selectDiv.append(createText);

                    setTimeout(() => {
                        createText.remove();
                    },2000);
                },1000);
            }
        } catch (error) {
            throw new Error(`func isA11yAddInputArea ${error}`);
        }
    }
      // 내부함수  
    isA11yAutoPlayAccess(sw){
        if (!this.$el.is(':visible')) return;
        if(!sw) return;

        console.log('????!@!@!@!')
        
        if(this.defaults.autoplay){
            //예외 페이지 및 디자인 다른 재생 분기처리
            if(this.defaults.paging){
                //paging 있을시
                // 20240626 버튼 속성 변경
                // const slideControlBtn = document.createElement('div');
                const slideControlBtn = document.createElement('button');
                slideControlBtn.setAttribute('class','swiper-pagination-bullet stop');
                slideControlBtn.setAttribute('aria-label', '일시정지');
                // slideControlBtn.setAttribute('role','button');
                slideControlBtn.setAttribute('type','button');

                let isToggle = true;

                $(slideControlBtn).on('click',(e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    toggleAutopaly();
                });

                // 구소스 개인PC 접근성 관련 키보드 이밴트 추가 (A11YTASK-536, A11YTASK-541, A11YTASK-542)
                $(slideControlBtn).on('keydown',(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if(e.key === 'Enter') toggleAutopaly(); // 엔터키 일때
                    if(e.shiftKey && e.key === 'Tab') $(e.target)?.prev()?.focus(); // 시프트 + 탭 일때 
                    if(e.key === 'Tab') $(e.target)?.blur(); // 탭 일때
                });
                
                this.$el.find('.swiper-pagination').append(slideControlBtn);

                function toggleAutopaly(){
                    if(isToggle){
                        sw.autoplay.stop();
                        slideControlBtn.setAttribute('class','swiper-pagination-bullet play');
                        slideControlBtn.setAttribute('aria-label', '재생');
                    }else{
                        sw.autoplay.start();
                        slideControlBtn.setAttribute('class','swiper-pagination-bullet stop');
                        slideControlBtn.setAttribute('aria-label', '일시정지');
                    }
                    
                    isToggle = !isToggle;

                    $(slideControlBtn).focus();
                }
            }else{
                //paging 없을시
            }
        }
    }
    // 내부함수    
    isRemoveSwiperWrapLive(){
        try {
            $(document).ready(function(){
                if(!isA11yCheckVersion()) return;
                $('.swiper-wrapper')?.removeAttr('aria-live');
                $('.swiper-slide[role="group"]').removeAttr('aria-label','role');
                isA11yButtonRole();// a 링크 버튼 적용
            });
        } catch{
            throw new Error('isRemoveSwiperWrapLive');
        }
    }
}

export default UISwiper;